import React from "react";
import ReactHtmlParser from "react-html-parser";
import {
  serverBubbleConfig,
  userBubbleConfig,
  DEFAULT_STATE,
  LOADING_STATE,
  STREAMING_STATE
} from "components/ai_tools/ChatBubble";
import CopyAndSaveReminder from "../shared/ChatArea/CopyAndSaveReminder";
import FreeTierUpgradeMessage from "../shared/ChatArea/FreeTierUpgradeMessage";
import InitialMessage from "../shared/ChatArea/InitialMessage";

// EVENTS //
export const ADD_LOADING_MESSAGE = "ADD_LOADING_MESSAGE";
export const ADD_USER_MESSAGE = "ADD_USER_MESSAGE";
export const UPDATE_STREAMING_MESSAGE = "UPDATE_STREAMING_MESSAGE";
export const FINALIZE_MESSAGE = "FINALIZE_MESSAGE";
export const ERROR_LAST_MESSAGE = "ERROR_LAST_MESSAGE";
export const ADD_REMINDER = "ADD_REMINDER";
export const ADD_UPGRADE_MESSAGE = "ADD_UPGRADE_MESSAGE";
export const RESET_TO_INITIAL = "RESET_TO_INITIAL";
export const PREPEND_MESSAGES = "PREPEND_MESSAGES";

// REDUCER //
export default function messagesReducer(state, action) {
  switch (action.type) {
    case ADD_USER_MESSAGE:
      return [...state, userBubbleConfig({ children: action.payload })];

    case ADD_LOADING_MESSAGE:
      return [...state, serverBubbleConfig({ streamState: LOADING_STATE })];

    case UPDATE_STREAMING_MESSAGE: {
      const { aiAnswerId, body } = action.payload;
      let index = state.findIndex((m) => m.aiAnswerId === aiAnswerId);

      if (index === -1) {
        index = state.length - 1; // fallback to last message
      }

      const message = state[index];

      // Prevent update if already finalized
      if (!message || message.streamState === DEFAULT_STATE) {
        return state;
      }

      const updated = {
        ...message,
        aiAnswerId,
        children: ReactHtmlParser(body),
        slideUp: false,
        streamState: STREAMING_STATE
      };

      return [...state.slice(0, index), updated, ...state.slice(index + 1)];
    }

    case FINALIZE_MESSAGE: {
      const { aiAnswerId, body } = action.payload;
      const index = state.findIndex((m) => m.aiAnswerId === aiAnswerId);

      if (index === -1) return state;

      const updated = {
        ...state[index],
        children: ReactHtmlParser(body),
        streamState: DEFAULT_STATE
      };
      return [...state.slice(0, index), updated, ...state.slice(index + 1)];
    }

    case ERROR_LAST_MESSAGE: {
      if (state.length === 0) return state;

      const errored = {
        ...state[state.length - 1],
        children: action.payload,
        streamState: DEFAULT_STATE
      };
      return [...state.slice(0, -1), errored];
    }

    case ADD_REMINDER:
      return [
        ...state,
        serverBubbleConfig({ children: <CopyAndSaveReminder /> })
      ];

    case ADD_UPGRADE_MESSAGE:
      return [
        ...state,
        serverBubbleConfig({
          children: (
            <FreeTierUpgradeMessage
              amplitudeKey={action.payload.amplitudeKey}
              signupPath={action.payload.signupPath}
            />
          )
        })
      ];

    case RESET_TO_INITIAL:
      return [
        serverBubbleConfig({
          children: (
            <InitialMessage
              toolName={action.payload.toolName}
              locked={action.payload.locked}
              inContent={action.payload.inContent}
              resourceTitle={action.payload.resourceTitle}
              upgradeable={action.payload.upgradeable}
              quotaRemaining={action.payload.quotaRemaining}
              signupPath={action.payload.signupPath}
            />
          ),
          slideUp: false
        })
      ];

    case PREPEND_MESSAGES:
      return [...action.payload, ...state];

    default:
      return state;
  }
}
